<template>
  <div class="content">
    <span class="success-icon yticon icon-xuanzhong2"></span>
    <span class="tit">支付成功</span>

    <div class="btn-div">
      <router-link
        v-if="orderNo.indexOf('PO')>-1"
        :to="{path:'/pages/order/order',query:{state:0}}"
        replace
        class="mix-btn"
      >查看订单</router-link>
      <router-link
        v-if="orderNo.indexOf('PO')==-1"
        :to="{path:'/onlinePages/order/virtualOrder',query:{state:0}}"
        replace
        class="mix-btn"
      >查看订单</router-link>
      <div @click="toHome" class="mix-btn hollow">返回首页</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      orderNo: ''
    }
  },
  created () {
    let query = this.$route.query
    this.orderNo = query.orderNo
  },
  methods: {
    toHome () {
      this.$router.replace('/')
      location.reload()
    },
  }
}
</script>

<style lang='scss' scoped>
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.success-icon {
  font-size: 80px;
  color: #fa436a;
  margin-top: 50px;
}
.tit {
  font-size: 19px;
  color: #303133;
}
.btn-div {
  padding-top: 50px;
}
.mix-btn {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 40px;
  font-size: $uni-font-size-lg;
  color: #fff;
  background-color: $base-color;
  border-radius: 5px;
  &.hollow {
    background: #fff;
    color: #303133;
    border: 1px solid #ccc;
  }
}
</style>
